/**
* Типы кнопок
*/
export var ButtonTypes;
(function (ButtonTypes) {
    /**
     * Основная (обычно синяя)
     */
    ButtonTypes[ButtonTypes["Primary"] = 1] = "Primary";
    /**
     * Дополнительная (обычно с синей рамкой)
     */
    ButtonTypes[ButtonTypes["Secondary"] = 2] = "Secondary";
    /**
     * Обычная (обычно без рамки)
     */
    ButtonTypes[ButtonTypes["Simple"] = 3] = "Simple";
})(ButtonTypes || (ButtonTypes = {}));
var UIButtonComponent = /** @class */ (function () {
    function UIButtonComponent() {
        var _a;
        this.isDisabled = false;
        this.icon = '';
        this.classes = (_a = {},
            _a[ButtonTypes.Primary] = 'primary',
            _a[ButtonTypes.Secondary] = 'secondary',
            _a[ButtonTypes.Simple] = 'simple',
            _a);
    }
    UIButtonComponent.prototype.ngOnInit = function () {
        this.class = this.classes[this.type];
    };
    return UIButtonComponent;
}());
export { UIButtonComponent };
